import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import { HttpParams } from '@angular/common/http';
import {Paginator} from '@models/paginator.type';

export interface Pageable {
    pageNumber: number;
    pageSize: number;
    sort: Sort;
    offset: number;
    paged: boolean;
    unpaged: boolean;
}

export interface Sort {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
}

export interface Page<T> {
    content: T[];
    pageable: Pageable;
    last: boolean;
    totalElements: number;
    totalPages: number;
    first: boolean;
    size: number;
    // eslint-disable-next-line id-blacklist
    number: number;
    sort: Sort;
    numberOfElements: number;
    empty: boolean;
}

export const paginatorToHttpParams = (
    paginator: Paginator,
    style: PageParamStyle = PageParamStyle.SPRING,
    matSort?: MatSort
): HttpParams => {
    if (paginator instanceof MatPaginator) return matPaginatorToHttpParams(paginator, style, matSort);
    else return simplePaginatorToHttpParams(paginator, style);
};

// todo: remove export of this function move all the usages to paginatorToHttpParams
export const matPaginatorToHttpParams = (
    matPaginator?: MatPaginator,
    style: PageParamStyle = PageParamStyle.SPRING,
    matSort?: MatSort
): HttpParams => {
    const schema: PageParamNames = PAGE_PARAM_STYLES[style];
    let params: HttpParams = new HttpParams();
    if (matPaginator) {
        params = params.set(schema.page, matPaginator?.pageIndex);
        params = params.set(schema.size, matPaginator?.pageSize);
    }
    if (matSort) params = params.set('sort', `${matSort.active},${matSort.direction}`);

    return params;
};

export const simplePaginatorToHttpParams = (
    paginator: { pageNumber: number; pageSize: number },
    style: PageParamStyle = PageParamStyle.SPRING
): HttpParams => {
    const schema: PageParamNames = PAGE_PARAM_STYLES[style];
    let params: HttpParams = new HttpParams();
    if (paginator) {
        params = params.set(schema.page, paginator.pageNumber);
        params = params.set(schema.size, paginator.pageSize);
    }
    return params;
};

export enum PageParamStyle {
    SPRING = 'spring',
    CUSTOM = 'custom'
}

interface PageParamNames {
    page: string;
    size: string;
}

const PAGE_PARAM_STYLES: Record<PageParamStyle, PageParamNames> = {
    [PageParamStyle.SPRING]: {page: 'page', size: 'size'},
    [PageParamStyle.CUSTOM]: {page: 'pageNumber', size: 'pageSize'}
}
